package es.subastia.navigation

import kotlinx.browser.window

object WebRouter {

    fun toPath(route: NavRoute): String {
        return when (route) {
            is NavRoute.Splash -> "/"
            is NavRoute.Main -> "/main"
            is NavRoute.SavedSearches -> "/saved"
            is NavRoute.Favorites -> "/favorites"
            is NavRoute.Profile -> "/profile"
            is NavRoute.AuctionList -> "/auctions"
            is NavRoute.AuctionFilter -> "/auctions/filter"
            is NavRoute.AuctionDetail -> "/detail/${route.id}"
            is NavRoute.Gallery -> window.location.pathname // Don't change the URL for gallery
        }
    }

    fun fromPath(path: String): List<NavRoute> {
        return when {
            path == "/" || path == "" -> listOf(NavRoute.Splash)
            path == "/main" -> listOf(NavRoute.Main)
            path == "/saved" -> listOf(NavRoute.SavedSearches)
            path == "/favorites" -> listOf(NavRoute.Favorites)
            path == "/profile" -> listOf(NavRoute.Profile)
            path == "/auctions" -> listOf(NavRoute.Main, NavRoute.AuctionList())
            path == "/auctions/filter" -> listOf(NavRoute.Main, NavRoute.AuctionList(), NavRoute.AuctionFilter)
            path.startsWith("/detail/") -> {
                val id = path.removePrefix("/detail/")
                if (id.isNotBlank()) {
                     listOf(NavRoute.Main, NavRoute.AuctionList(), NavRoute.AuctionDetail(id))
                } else {
                     listOf(NavRoute.Main)
                }
            }
            else -> listOf(NavRoute.Main) // Fallback
        }
    }

    fun syncUrl(route: NavRoute) {
        val path = toPath(route)
        if (window.location.pathname != path) {
             window.history.pushState(null, "", path)
        }
    }
}
